<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

import { goLogin } from '@/utils'
import { getToken } from '@/utils/cookies'

export default {
  name: 'App',
  created() {
    if (!getToken()) {
      goLogin()
    } else {
      this.$store.dispatch('config/monitorAliyunFP')
      this.$store.dispatch('user/getInfo')
      this.$store.dispatch('user/getTeamList')
    }
  }
}
</script>
